import React from "react";
import { Box, Typography } from "@mui/material";

// Replace with actual background image path when available
import bgBlock from "../assets/seven/backgroundImage.png";

const StoreCard = ({ store }) => {
  return (
    <Box
      onClick={() => {
        window.location.href = "https://pide.mennu.mx/7-eleven";
      }}
      sx={{
        width: "100%",
        height: 140, // Adjust based on your preferred aspect ratio
        backgroundImage: `url(${bgBlock})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
        },
      }}
    >
      {/* Semi-transparent blue overlay if needed (the image might already have it) */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 121, 83, 0.6)", // Adjust color and opacity to match design
          zIndex: 1,
        }}
      />
      
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          px: 2,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: "white",
            fontWeight: "bold",
            mb: 0.5,
            textShadow: "1px 1px 3px rgba(0,0,0,0.8)", // Stronger text shadow
            fontSize: "0.95rem"
          }}
        >
          {store.name.split(' ')[0]} {/* e.g., "Sucursal" */}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: "white",
            fontWeight: 800,
            lineHeight: 1.1,
            mb: 1,
            textShadow: "1px 1px 4px rgba(0,0,0,0.9)", // Stronger text shadow
            fontSize: "1.3rem"
          }}
        >
          {store.name.split(' ').slice(1).join(' ')} {/* e.g., "Monterrey 1" */}
        </Typography>
        <Box 
          sx={{ 
            backgroundColor: "rgba(0, 0, 0, 0.45)", // Semi-transparent dark background
            padding: "4px 8px", 
            borderRadius: "6px",
            display: "inline-block" // So it only takes up as much width as the text
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "#ffffff", // Pure white for better contrast
              display: "block",
              fontSize: "0.75rem", // Slightly larger
              fontWeight: 600, // Make it slightly bolder
              lineHeight: 1.3,
            }}
          >
            {store.hours}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StoreCard;
